module.exports = __webpack_public_path__ + "static/img/2.2b30d56.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/zh/2.png
// module id = g7gq
// module chunks = 0